import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const MobileDtctrDetail = ({
                             propName = "",
                             propStatus
                           }) => {
  return (
      <>
        <h6 className={"info-container-title text-center mt-3"}>{propName} 상태 정보</h6>
        <div className={'content-container-body-item'}>
          <Form
              className={'gateway-register-form py-3'}
              id={'gatewayRegisterForm'}
          >
            <Row className={""}>
              <Col md={6}>
                <Row>
                  <Col md={12}>
                    <Form.Group as={Row} controlId="formFcltyNm">
                      <Form.Label column md={4} className={'label text-end'}>
                        최근수집시간
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.mesure_dt_str || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFloor'>
                      <Form.Label column md={4} className={'label text-end'}>
                        펌웨어버전
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.fw_ver || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        온도
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.tp || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        소동물감지 설정
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.small_animal_motion_at || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label  text-end'}>
                        LED 설정
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.led_motion_at || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        민감도 설정
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.snstive_at || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        온도상승율
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.tp_rising_rate || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                </Row>
              </Col>

              <Col md={6}>
                <Row>
                  <Col md={12}>
                    <Form.Group as={Row} controlId="formFcltyNm">
                      <Form.Label column md={4} className={'label text-end'}>
                        저전압
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.low_vlt_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFloor'>
                      <Form.Label column md={4} className={'label text-end'}>
                        템퍼 상태
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.tamper_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formEqmTy'>
                      <Form.Label column md={4} className={'label text-end'}>
                        Flash 상태
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.flash_err_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        경보발생
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.alarm_ocrn_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        동작감지
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propStatus.motion_sttus || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                </Row>
              </Col>

            </Row>
          </Form>
        </div>
      </>
  );
};

export default MobileDtctrDetail;
